import { render, staticRenderFns } from "./mt-radio-button.vue?vue&type=template&id=3650aad9&"
import script from "./mt-radio-button.vue?vue&type=script&lang=js&"
export * from "./mt-radio-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports